import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { FaDatabase, FaFileAlt, FaUserShield } from "react-icons/fa";

function DashboardPage(){

const [assets,setAssets] = useState([])
const [documents,setDocuments] = useState([])
const [wills,setWills] = useState([])

useEffect(()=>{

fetch("https://final-trace.onrender.com/api/assets/all")
.then(res=>res.json())
.then(data=>{
setAssets(data)
})

fetch("https://final-trace.onrender.com/api/documents/all")
.then(res=>res.json())
.then(data=>{
setDocuments(data)
})

fetch("https://final-trace.onrender.com/api/will/all")
.then(res=>res.json())
.then(data=>{
setWills(data)
})

},[])

return(

<div className="container">

<h1>Dashboard</h1>
<p>Manage your digital legacy.</p>

{/* Statistics Cards */}

<div style={{
display:"flex",
gap:"20px",
marginTop:"20px"
}}>

<div style={{
flex:"1",
background:"#1e3c72",
color:"white",
padding:"20px",
borderRadius:"10px",
textAlign:"center"
}}>
<FaDatabase size={40}/>
<h2>{assets.length}</h2>
<p>Total Assets</p>
</div>

<div style={{
flex:"1",
background:"#2a5298",
color:"white",
padding:"20px",
borderRadius:"10px",
textAlign:"center"
}}>
<FaFileAlt size={40}/>
<h2>{documents.length}</h2>
<p>Uploaded Documents</p>
</div>

<div style={{
flex:"1",
background:"#4f46e5",
color:"white",
padding:"20px",
borderRadius:"10px",
textAlign:"center"
}}>
<FaUserShield size={40}/>
<h2>{wills.length}</h2>
<p>Digital Wills</p>
</div>

</div>

{/* Action Buttons */}

<div style={{marginTop:"30px"}}>

<Link to="/assets">
<button style={{marginRight:"10px"}}>
Add Digital Asset
</button>
</Link>

<Link to="/upload">
<button style={{marginRight:"10px"}}>
Upload Documents
</button>
</Link>

<Link to="/will">
<button>
Write Digital Will
</button>
</Link>

</div>

{/* Saved Assets */}

<h2 style={{marginTop:"40px"}}>Saved Assets</h2>

<div style={{marginTop:"20px"}}>

{assets.map((asset)=>(
<div
key={asset._id}
style={{
border:"1px solid #e5e7eb",
padding:"16px",
marginBottom:"12px",
borderRadius:"10px",
background:"#f8fafc",
boxShadow:"0 4px 10px rgba(0,0,0,0.1)"
}}
>

<b>Type:</b> {asset.assetType || "N/A"} <br/>
<b>Account:</b> {asset.accountName || "N/A"} <br/>
<b>Username:</b> {asset.username} <br/>
<b>Instructions:</b> {asset.instructions || "None"}

</div>
))}

</div>

</div>

)

}

export default DashboardPage